export default {
  name: 'my',
  path: '/my',
  component: () => import('@/views/my'),
  children: [
    {
      name: 'my-index', // 我的首页
      path: '',
      meta: {
        auth: true
      },
      component: () => import('@/views/my/entry')
    },
    {
      name: 'user-center', // 个人中心
      path: 'userCenter',
      component: () => import('@/views/my/userCenter'),
      children: [
        {
          name: 'user-center-index', // 首页
          path: '',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/entry.vue')
        },
        {
          name: 'user-center-info', // 个人信息
          path: 'info',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/info.vue')
        },
        {
          name: 'user-center-reset-pass', // 修改密码
          path: 'resetPassword',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/reset-password.vue')
        },
        {
          name: 'user-center-reset-phone', // 重置手机
          path: 'resetPhone',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/reset-phone.vue')
        },
        {
          name: 'user-center-personal-auth', // 个人认证
          path: 'auth/personal',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/auth.vue')
        },
        {
          name: 'user-center-org-auth', // 企业认证
          path: 'auth/org',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/orgAuth.vue')
        },
        {
          name: 'user-center-bind-wx', // 绑定微信
          path: 'bind',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/userCenter/bind-wx.vue')
        },
        {
          name: 'user-address', // 地址管理
          path: 'address',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/address/index.vue')
        },
        {
          name: 'add-address', // 新增收货人
          path: 'address/edit',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/address/edit.vue')
        },
        {
          name: 'project-index', // 项目地址管理
          path: 'project',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/address/project.vue')
        },
        {
          name: 'project-add', // 新增编辑项目
          path: 'project/add',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/address/project-edit.vue')
        },
        {
          name: 'message-center', // 我的消息
          path: 'message',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/message/index.vue')
        },
        {
          name: 'message-system', // 系统消息
          path: 'message/system',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/message/system.vue')
        },
        {
          name: 'message-service', // 服务消息
          path: 'message/service',
          meta: {
            auth: true
          },
          component: () => import('@/views/my/message/service.vue')
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/my.js